class Rock {
  constructor (view) {
    this.view = view
    this.isHit = false
  }

  hit () {
    this.isHit = true
  }

  reset () {
    this.isHit = false
  }

  destroy() {
    this.view.parent = null
    this.view.isVisible = false
    this.view.dispose()
  }
}

export default Rock